import React, { useState, useEffect } from "react";
import style from "./Login.css";
import nestlogo from "../../assets/APPROVED_NEST TYPO DARK.svg";
import { FaSpinner, FaLock, FaUserCircle } from "react-icons/fa";
import { API_URL } from "../../constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setAuthentication } from "../../store/reducers/auth";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import SessionOverrideModal from "../../components/SessionOverrideModal";
import TwoFactorVerify from "../../components/TwoFactorVerify";
import userIcon from "../../assets/Nest_User_icon.png";

const Login = () => {
  const search = useLocation().search;
  const unauthorize = new URLSearchParams(search).get("unauthorize");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    force: 0,
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [otpCode, setOTPCode] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [isFlipped, setIsFlipped] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showUserExitsModal, setUserExitsModal] = useState(false);
  const [twoFactorUserId, setTwoFactorUserId] = useState(null);
  const [QrCodeURL, setQRCodeURL] = useState(null);

  

    useEffect(() => {
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const rememberedPasssword = localStorage.getItem("rememberedPassword");
    if (rememberedEmail) {
      setFormData(prev => ({ ...prev, email: rememberedEmail, password: rememberedPasssword }));
      setRememberMe(true);
    }

    if (unauthorize) {
      toast.error("Session is expired, please login again.");
    }
  }, [unauthorize]);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    let error = "";
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (fieldName === "email") {
      if (!value) {
        error = "Email is required";
      } else if (!emailRegex.test(value)) {
        error = "Valid email required";
      }
    } else if (fieldName === "password") {
      if (!value) {
        error = "Password is required";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [fieldName]: error,
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    // Validate email
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Valid email required";
      isValid = false;
    } else {
      newErrors.email = "";
    }

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    } else {
      newErrors.password = "";
    }

    setErrors(newErrors);
    return isValid;
  };


  const handleForceLogin = async () => {
    // Update form data with force flag
    setFormData((prevData) => ({
      ...prevData,
      force: 1,
    }));

    if (!validateForm()) {
      toast.error("Please fill all required fields");
      return;
    }

    setSubmitted(true);

    try {
      const response = await axios.post(`${API_URL}login`, {
        ...formData,
        force: 1, // Ensure force flag is included
      });

      const result = response.data;
      if (response.data.two_factor_required) {
        setQRCodeURL(response.qrCodeUrl);
        setIsFlipped(true);
        setSecretKey(response?.data?.secretKey);
        setTwoFactorUserId(response.data.user_id);
        // Show 2FA verification component, passing the user ID
        // return <TwoFactorVerify userId={response.data.user_id} />;
      }

      if (result.status === "success") {
        const authData = {
          token: result.data.token,
          user: result.data.user,
          menu: result.data.menu,
          permissions: result.data.permissions,
          rujul_menu: result.data.rujul_menu,
        };

        // Store auth data
        localStorage.setItem("token", authData.token);
        localStorage.setItem("user", JSON.stringify(authData.user));
        localStorage.setItem("menu", JSON.stringify(authData.menu));
        localStorage.setItem(
          "permission",
          JSON.stringify(authData.permissions)
        );
        localStorage.setItem("rujul_menu", JSON.stringify(authData.rujul_menu));

        await dispatch(setAuthentication(authData));
        console.log("result.message:::",result.message);
        
        // toast.success(result.message, {
        //   style: { marginTop: "25px" },
        // });
        let redirectPath = localStorage.getItem("pathname");
        if (redirectPath) {
          navigate(redirectPath);
          setTimeout(() => {
            localStorage.removeItem("pathname");
          }, 10000);
        } else {
          navigate("/");
        }
        // toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Force login error:", error);

      if (error.response?.status === 403) {
        toast.error("Force login failed: Access denied");
      } else if (error.response?.status !== 409) {
        toast.error(error.response?.data?.message || "Force login failed");
      }
    } finally {
      setSubmitted(false);
      setUserExitsModal(false); // Close the modal after attempt
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
   // Handle Remember Me functionality
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", formData.email);
      localStorage.setItem("rememberedPassword", formData.password);
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }
    setSubmitted(true);
    try {
      const response = await axios.post(API_URL + "login", formData);
      const result = response.data;

      if (response.data.two_factor_required) {
        setQRCodeURL(response?.data?.qrCodeUrl);
        setIsFlipped(true);
        setSecretKey(response?.data?.secretKey);
        setTwoFactorUserId(response.data.user_id);
        // Show 2FA verification component, passing the user ID
        // return <TwoFactorVerify userId={response.data.user_id} />;
      }

      if (result.status === "success") {
        // Store authentication data
        const authData = {
          token: result.data.token,
          user: result.data.user,
          menu: result.data.menu,
          permissions: result.data.permissions,
          rujul_menu: result.data.rujul_menu,
        };

        // Save to localStorage
        localStorage.setItem("token", authData.token);
        localStorage.setItem("user", JSON.stringify(authData.user));
        localStorage.setItem("menu", JSON.stringify(authData.menu));
        localStorage.setItem(
          "permission",
          JSON.stringify(authData.permissions)
        );
        localStorage.setItem("rujul_menu", JSON.stringify(authData.rujul_menu));

        // Update Redux store
        await dispatch(setAuthentication(authData));
        // toast.success(result.message);
        // toast.success(result.message, {
        //   style: { marginTop: "25px" },
        // });
        let redirectPath = localStorage.getItem("pathname");
        if (redirectPath) {
          navigate(redirectPath);
          setTimeout(() => {
            localStorage.removeItem("pathname");
          }, 10000);
        } else {
          navigate("/");
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Login error:", error);

      if (error.response?.status === 403) {
        // User already logged in case
        setUserExitsModal(true);
      } else if (error.response?.status !== 403) {
        // Show error for all cases except 403 (Forbidden)
        toast.error(error.response?.data?.message || "Login failed");
      }
    } finally {
      setSubmitted(false);
    }
  };


  const handleVerify = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Handle Remember Me functionality
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", formData.email);
      localStorage.setItem("rememberedPassword", formData.password);
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }
    setSubmitted(true);
    try {
      const response = await axios.post(API_URL + "login", {
        ...formData,
        otp: otpCode,
        secretKey: secretKey,
      });
      const result = response.data;

      if (response.data.two_factor_required) {
        setIsFlipped(true);

        setTwoFactorUserId(response.data.user_id);
        // Show 2FA verification component, passing the user ID
        // return <TwoFactorVerify userId={response.data.user_id} />;
      }

      if (result.status === "success") {
        // Store authentication data
        const authData = {
          token: result.data.token,
          user: result.data.user,
          menu: result.data.menu,
          permissions: result.data.permissions,
          rujul_menu: result.data.rujul_menu,
        };
        // Save to localStorage
        localStorage.setItem("token", authData.token);
        localStorage.setItem("user", JSON.stringify(authData.user));
        localStorage.setItem("menu", JSON.stringify(authData.menu));
        localStorage.setItem(
          "permission",
          JSON.stringify(authData.permissions)
        );
        localStorage.setItem("rujul_menu", JSON.stringify(authData.rujul_menu));

        // Update Redux store
        await dispatch(setAuthentication(authData));
        // toast.success(result.message);
        // toast.success(result.message, {
        //   style: { marginTop: "25px" },
        // });
        let redirectPath = localStorage.getItem("pathname");
        if (redirectPath) {
          navigate(redirectPath);
          setTimeout(() => {
            localStorage.removeItem("pathname");
          }, 10000);
        } else {
          navigate("/dashboard");
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error("Login error:", error);

      if (error.response?.status === 403) {
        // User already logged in case
        setUserExitsModal(true);
      } else if (error.response?.status !== 403) {
        // Show error for all cases except 403 (Forbidden)
        toast.error(error.response?.data?.message || "Login failed");
      }
    } finally {
      setSubmitted(false);
    }
  };
  // Add useEffect to handle automatic submission when force changes

  const handleUserExitsModalClose = () => {
    setUserExitsModal(false);
  };


  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <>
      <div className="nest-login-page">
        <div className={`flip-container ${isFlipped ? "flipped" : ""}`}>
          <div className="flipper">
            <div className="front">
              <div className="container">
                <div className="row">
                  <div className="text-center logo-mobile-only">
                    <img src={nestlogo} className="logoImgLogin" alt="Logo" />
                  </div>
                  <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div className="login-container">
                      <img src={userIcon} alt="user_Icon" />
                      <form className="login-form" onSubmit={handleSubmit}>
                        <div className="login-form-group">
                          <span className="fa fa-user-o form-control-icon login-input-icon"></span>
                          <input
                            type="text"
                            onChange={handleInputChange}
                            className={
                              errors.email
                                ? "form-control login-form-control invalids"
                                : "form-control login-form-control"
                            }
                            id="email"
                            name="email"
                            value={formData.email}
                            placeholder="Email"
                            style={{
                              margin: "0px",
                              backgroundColor: "transparent",
                              color: "#66c4de",
                              WebkitTextFillColor: "#66c4de",
                              transition: "background-color 5000s ease-in-out 0s",
                            }}
                          />
                        </div>
                        {errors.email && (
                          <div className="login-error text-start">{errors.email}</div>
                        )}
                        <div className="login-form-group mt-2">
                          <span className="fa fa-key form-control-icon login-input-icon"></span>
                          <input
                            type="password"
                            onChange={handleInputChange}
                            className={
                              errors.password
                                ? "form-control login-form-control invalids"
                                : "form-control login-form-control"
                            }
                            id="password"
                            name="password"
                            value={formData.password}
                            placeholder="Password"
                            style={{
                              margin: "0px",
                              backgroundColor: "transparent",
                              color: "#66c4de",
                              WebkitTextFillColor: "#66c4de",
                              transition:
                                "background-color 5000s ease-in-out 0s",
                            }}
                          />
                          <span
                            className="fa fa-eye-slash form-control-icon password-toggle-icon"
                            onClick={(e) => {
                              const input = e.target
                                .closest(".login-form-group")
                                .querySelector("input");
                              input.type =
                                input.type === "password" ? "text" : "password";
                              e.target.classList.toggle("fa-eye-slash");
                              e.target.classList.toggle("fa-eye");
                            }}
                            style={{
                              cursor: "pointer",
                              right: "15px",
                              left: "auto",
                            }}
                          ></span>
                        </div>
                        {errors.password && (
                          <div className="login-error text-start">{errors.password}</div>
                        )}
                        <div className="d-flex justify-content-between">
                          <div>
                            <div class="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                                id="rememberMeCheckbox"
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckChecked"
                                style={{ color: "#66c4de" }}
                              >
                                Remember Me
                              </label>
                            </div>
                          </div>
                          <div className="bottom-text">
                            <p>
                              <p style={{ cursor: "pointer" }}
                                onClick={handleForgotPassword}
                              >
                                Forgot password?
                              </p>
                            </p>
                          </div>
                        </div>
                        <div className="text-center">
                          <button
                            style={{
                              width: "70%",
                              padding: "10px",
                              borderRadius: "30px",
                              background: "#2BB2FF",
                              color: "white",
                              border: "none",
                              fontWeight: "bold",
                              marginTop: "20px",
                            }}
                            disabled={submitted}
                            type="submit"
                            className="login-custom"
                          >
                            {submitted ? (
                              <FaSpinner className="sm-spinner" />
                            ) : (
                              "LOGIN"
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* <div className="col-12 col-md-6"></div> */}
                </div>
              </div>
            </div>
            {/* BACK: Verification Form */}
            <div className="back">
              <div className="container">
                <div className="row align-items-center">
                  {/* Left Side: QR and Form */}
                  <div className="col-sm-6 d-flex justify-content-start">
                    <div
                      style={{
                        padding: "30px",
                        borderRadius: "15px",
                        width: "350px",
                        textAlign: "center",
                        // color: "white",
                        background: "rgba(255, 255, 255, 0.1)",
                        boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                        border: "1px solid rgba(255, 255, 255, 0.18)",
                      }}
                    >
                      <strong
                        style={{
                          fontSize: "24px",
                          display: "block",
                          marginBottom: "10px",
                          color: "#27568B",
                        }}
                      >
                        Verify
                      </strong>
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#27568B",
                          marginBottom: "20px",
                        }}
                      >
                        {QrCodeURL
                          ? "Please scan the QR code using the Microsoft Authenticator app and enter the verification code below."
                          : "Please enter the verification code from the Microsoft Authenticator app."}
                      </p>

                      {QrCodeURL ? (
                        <TwoFactorVerify QrCodeurll={QrCodeURL} />
                      ) : null}

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Verification Code"
                        style={{
                          marginBottom: "15px",
                          borderRadius: "6px",
                          padding: "8px",
                          border: "1px solid rgb(183, 188, 194)",
                          backgroundColor: "transparent",
                          color: "#27568B", // Change to white if dark background
                        }}
                        onChange={(e) => setOTPCode(e.target.value)}
                      />

                      <button
                        disabled={submitted}
                        type="button"
                        onClick={(e) => handleVerify(e)}
                        style={{
                          width: "70%",
                          padding: "10px",
                          borderRadius: "30px",
                          background: "#2BB2FF",
                          color: "white",
                          border: "none",
                          fontWeight: "bold",
                        }}
                      >
                        {submitted ? (
                          <FaSpinner className="sm-spinner" />
                        ) : (
                          "LOGIN"
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Right Side: Optional image/design */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <SessionOverrideModal
          show={showUserExitsModal}
          onCancel={handleUserExitsModalClose}
          onOverride={handleForceLogin}
        />
      </div>
    </>
  );
};

export default Login;
